import {Input} from 'antd'
import {docs_searchCodiDocumentRows_Api} from 'apis'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import {getLinkToDetailRow} from './codiHelpers'
import EntityList from '../EntityList'
import {bindQueryParam} from '../functions/routerHelper'
import CodiContext from './CodiContext'
import {GiIronCross} from "react-icons/gi";
import LoadingBlock from "../../LoadingBlock";

const renderResultItem = (item, index) => {
    const {
        content,
        index_cd,
        index_typecd,
        short_index_name,
        children = [],
    } = item ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <Link
                    className="w-full space-x-1 p-2 text-sm border border-color-50 rounded-md hover:shadow-items no-underline"
                    to={getLinkToDetailRow(item)}>
                    {short_index_name && (
                        <span className="font-semibold text-color-000 hover:text-primary italic">
                          {`${short_index_name} : `}
                      </span>
                    )}
                    {content && (
                        <span className={short_index_name === null ? 'font-medium text-color-100 italic' : 'text-color-300'}>{content}</span>
                    )}
                </Link>
            )}
        </Translate>
    )
}

const SearchInput = ({keyword, onChange = NullAsDefault, ...props}) => (
    <Translate>
        {(t) => (
            <div className="flex flex-col gap-1">
                <Input.Search
                    allowClear={true}
                    defaultValue={keyword}
                    placeholder={t('enter your keyword')}
                    onSearch={(value) => {
                        onChange(value)
                    }}
                    onChange={(event) => {
                        const {value} = event.target
                        onChange(value)
                    }}
                    {...props}
                />
                {keyword ?
                    <span className="text-sm text-color-400 italic ml-1 mt-1">
                        <GiIronCross size={10}/> {t('results found with keywords')} {' : '}
                        <span className="font-bold text-color-000">{keyword}</span>
                    </span> :
                    <span className="text-xs text-color-500 italic ml-1">
                        {t('example : enter keyword')}
                    </span>
                }
            </div>
        )}
    </Translate>
)

const SearchResult = ({Wrapper = 'div', keyword, renderItem, ...props}) => (
    <Wrapper className="flex flex-col gap-3">
        <EntityList
            key={keyword}
            values={{keyword}}
            refreshKey={keyword}
            renderItem={renderItem}
            RenderEntity={React.Fragment}
            renderLoading={() => <LoadingBlock/>}
            apiInfo={docs_searchCodiDocumentRows_Api}
            {...props}
        />
    </Wrapper>
)

const CodiSearch = () => {
    const t = useTranslate()

    const [keyword, setKeyword] = useState()

    const {item} = useContext(CodiContext)

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 300)

    return (
        <div className="flex flex-col gap-2">
            <div className="space-x-2">
        <span className="text-sm text-color-400 italic">
            {`${t('book name')} : `}
        </span>
                <span className="font-bold text-color-000">{getTitle(item)}</span>
            </div>
            <SearchInput
                keyword={keyword}
                onChange={onSearch}
            />
            <SearchResult
                keyword={keyword}
                renderItem={renderResultItem}
                query={bindQueryParam({id: item?.id})}
            />
        </div>
    )
}

export default CodiSearch
